import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  RequestSiteVisit1o0qmklsbtvus as RequestSiteVisit,
  RequestResolveLater_instance1haqv4qpxez7b as RequestResolveLater_instance,
  RemedyComplete1j0nrocri3mi3 as RemedyComplete,
  Remedy1wqpxp6byw9t6 as Remedy,
  Credit2hxrirfggfkql as Credit,
  Appeal_instance3s9wpeu612ekq as Appeal_instance,
  Handled3ngpo7bepl0ux as Handled,
  ForceCompletemak8s8g9i3mp as ForceComplete,
  RequestComplete2fbpvksxlxjbf as RequestComplete,
  MoreInfo_instance2thszg9d7ysff as MoreInfo_instance,
  KeepWorking_instance1l6z7q2tbtqni as KeepWorking_instance,
  Appealdu3t1bemwr4j as Appeal,
} from '../../../../crowpay-shared/com/crowpay/completionResponse/CompletionResponse.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
} from '../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { Triple1vhi3d0dgpnjb as Triple } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  Formats_getInstance5hp5sczkglnx as Formats_getInstance,
  format1crnfsffhjur0 as format,
} from '../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import {
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  toString3o7ifthqydp6e as toString_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function acceptActionName(_this__u8e3s4, history) {
  var tmp;
  if (_this__u8e3s4 instanceof RequestComplete()) {
    tmp = 'Approve Work';
  } else {
    if (_this__u8e3s4 instanceof ForceComplete()) {
      tmp = 'Accept ' + _this__u8e3s4.x8y(history);
    } else {
      if (_this__u8e3s4 instanceof Handled()) {
        tmp = 'Accept ' + _this__u8e3s4.x8y(history);
      } else {
        if (equals(_this__u8e3s4, Appeal_instance)) {
          tmp = 'Accept Appeal';
        } else {
          if (_this__u8e3s4 instanceof Credit()) {
            tmp = 'Accept Credit (' + MonetaryValue__toString_impl_xslc77(_this__u8e3s4.p8z_1) + ')';
          } else {
            if (_this__u8e3s4 instanceof Remedy()) {
              tmp = 'Accept ' + _this__u8e3s4.x8y(history);
            } else {
              if (_this__u8e3s4 instanceof RemedyComplete()) {
                tmp = 'Approve Work';
              } else {
                if (equals(_this__u8e3s4, RequestResolveLater_instance)) {
                  tmp = 'Accept Resolve Later';
                } else {
                  if (_this__u8e3s4 instanceof RequestSiteVisit()) {
                    tmp = 'Confirm Visit';
                  } else {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function acceptConfirmationText(_this__u8e3s4, permissions) {
  var tmp;
  if (_this__u8e3s4 instanceof RequestComplete()) {
    tmp = new (Triple())('Approve & Release ' + permissions.i8x_1.j6k_1, 'Approving this work item releases funds to the contractor as payment.', 'Approve');
  } else {
    if (_this__u8e3s4 instanceof ForceComplete()) {
      tmp = new (Triple())('Accept Force Complete?', 'This releases funds for collection. The contractor has stated the work is complete.', 'Accept Force Complete');
    } else {
      if (_this__u8e3s4 instanceof Handled()) {
        tmp = new (Triple())('Accept Handled?', 'This releases funds for collection. The concerns you raised will be marked as handled.', 'Accept Handled');
      } else {
        if (equals(_this__u8e3s4, Appeal_instance)) {
          tmp = new (Triple())('Accept Appeal?', "This accepts the contractor's appeal and settles the dispute. Funds will be released for collection.", 'Accept Appeal');
        } else {
          if (_this__u8e3s4 instanceof Credit()) {
            tmp = new (Triple())('Accept Credit?', 'This accepts the ' + MonetaryValue__toString_impl_xslc77(_this__u8e3s4.p8z_1) + ' credit and settles the dispute. Funds will be released for collection less the credit amount.', 'Accept Credit');
          } else {
            if (_this__u8e3s4 instanceof Remedy()) {
              // Inline function 'kotlin.text.buildString' call
              // Inline function 'kotlin.apply' call
              var this_0 = StringBuilder().d1();
              this_0.wb("This accepts the contractor's remedy plan. Contractor will complete the agreed work and request sign-off. You can review and accept at that point, ");
              var tmp_0 = _this__u8e3s4.g8z_1;
              if (!((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null)) {
                var tmp_1 = _this__u8e3s4.g8z_1;
                this_0.wb('when the ' + toString(tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) + ' credit will be applied, ');
              }
              this_0.wb('or continue the dispute process if concerns remain. Lock project will be unavailable during plan implementation.');
              var tmp$ret$2 = this_0.toString();
              tmp = new (Triple())('Accept Remedy Plan?', tmp$ret$2, 'Accept Remedy Plan');
            } else {
              if (equals(_this__u8e3s4, RequestResolveLater_instance)) {
                tmp = new (Triple())('Resolve Later?', 'This will stop any work and funds release for the line item. At the end of the project the line item will be revisited and problems addressed.', 'Accept Resolve Later');
              } else {
                if (_this__u8e3s4 instanceof RemedyComplete()) {
                  var tmp_2 = 'Accept Complete & Pay ' + permissions.i8x_1.j6k_1 + '?';
                  var tmp1_elvis_lhs = _this__u8e3s4.w8y_1.g8z_1;
                  var tmp_3;
                  var tmp_4 = tmp1_elvis_lhs;
                  if ((tmp_4 == null ? null : new (MonetaryValue())(tmp_4)) == null) {
                    tmp_3 = Companion_instance.r91(0n);
                  } else {
                    tmp_3 = tmp1_elvis_lhs;
                  }
                  tmp = new (Triple())(tmp_2, 'Approving this will complete the line item and apply ' + MonetaryValue__toString_impl_xslc77(tmp_3) + ' of credit to the line item. It will then pay out the remaining balance to the contractor.', 'Accept Complete');
                } else {
                  if (_this__u8e3s4 instanceof RequestSiteVisit()) {
                    tmp = permissions.t8w() ? new (Triple())('Confirm Visit?', 'This confirms the on-site meeting. Meet to discuss the dispute, then the contractor will propose a settlement based on your discussion.', 'Confirm Visit') : new (Triple())('Confirm Visit?', 'This pauses the funds release timer and notifies the contractor to schedule an on-site meeting to address your concerns.', 'Confirm Visit');
                  } else {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function sendActionName(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof RequestComplete()) {
    tmp = 'Request Complete';
  } else {
    if (equals(_this__u8e3s4, KeepWorking_instance)) {
      tmp = 'More Work';
    } else {
      if (_this__u8e3s4 instanceof Handled()) {
        tmp = 'Submit Handled';
      } else {
        if (equals(_this__u8e3s4, MoreInfo_instance)) {
          tmp = 'Request More Info';
        } else {
          if (_this__u8e3s4 instanceof ForceComplete()) {
            tmp = 'Force Complete';
          } else {
            if (equals(_this__u8e3s4, RequestResolveLater_instance)) {
              tmp = 'Resolve Later';
            } else {
              if (equals(_this__u8e3s4, Appeal_instance)) {
                tmp = 'Submit Appeal';
              } else {
                if (_this__u8e3s4 instanceof Credit()) {
                  tmp = 'Propose Credit';
                } else {
                  if (_this__u8e3s4 instanceof Remedy()) {
                    tmp = 'Submit Remedy Plan';
                  } else {
                    if (_this__u8e3s4 instanceof RequestSiteVisit()) {
                      tmp = 'Request Visit';
                    } else {
                      tmp = 'Select a Response';
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function sendConfirmationText(_this__u8e3s4, autoRelease, permissions) {
  var tmp1_elvis_lhs = autoRelease == null ? null : format(autoRelease, Formats_getInstance().i8z_1);
  var autoReleaseAt = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  var tmp;
  if (equals(_this__u8e3s4, MoreInfo_instance)) {
    tmp = new (Triple())('Request More Info?', 'This pauses the funds release timer and sends your request to the client. Funds will release on ' + autoReleaseAt + " if they don't respond.", 'Submit');
  } else {
    if (equals(_this__u8e3s4, KeepWorking_instance)) {
      tmp = new (Triple())('Submit More Work?', 'This acknowledges additional work is needed and clears the funds release timer. Request sign-off again when the work is complete.', 'Submit');
    } else {
      if (_this__u8e3s4 instanceof Handled()) {
        tmp = new (Triple())('Submit Handled?', 'This states the concerns have been addressed and resumes the funds release timer. The client can accept or respond if concerns remain.', 'Submit');
      } else {
        if (_this__u8e3s4 instanceof ForceComplete()) {
          var escalated = permissions.s8w() ? 'a dispute' : 'an issue';
          tmp = new (Triple())('Submit Force Complete?', 'This states the work is complete and resumes the funds release timer. The client can accept or escalate to ' + escalated + ' if they disagree.', 'Submit');
        } else {
          if (_this__u8e3s4 instanceof RequestSiteVisit()) {
            tmp = permissions.t8w() ? new (Triple())('Request Visit?', 'This requests an on-site meeting to discuss the dispute. If client confirms the meeting, submit your proposed settlement afterward.', 'Submit') : new (Triple())('Request Visit?', 'This resumes the funds release timer and requests an on-site meeting. Timer pauses once client confirms. Submit your response after the meeting.', 'Submit');
          } else {
            if (_this__u8e3s4 instanceof Credit()) {
              tmp = new (Triple())('Propose Credit?', 'This offers a ' + MonetaryValue__toString_impl_xslc77(_this__u8e3s4.p8z_1) + ' credit to settle the dispute. Client can accept the credit or continue dispute discussion. Funds remain on hold until dispute is settled.', 'Submit');
            } else {
              if (_this__u8e3s4 instanceof Remedy()) {
                tmp = new (Triple())('Submit Remedy Plan?', 'This submits your plan to settle the dispute. Client can accept your plan, propose modifications, or continue dispute discussion. Funds remain on hold until dispute is settled.', 'Submit');
              } else {
                if (_this__u8e3s4 instanceof Appeal()) {
                  tmp = new (Triple())('Submit Appeal?', 'This formally challenges the dispute. Client can accept your position or continue discussion. Funds remain on hold until dispute is settled.', 'Submit');
                } else {
                  tmp = new (Triple())(sendActionName(_this__u8e3s4) + toString_0(_Char___init__impl__6a9atx(63)), '', sendActionName(_this__u8e3s4));
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
//region block: exports
export {
  acceptActionName as acceptActionName1soryjzupmune,
  acceptConfirmationText as acceptConfirmationText15yt66nimg6we,
  sendActionName as sendActionName2meg4tvhm5rsl,
  sendConfirmationText as sendConfirmationText2zujg5wbkbmsp,
};
//endregion

//# sourceMappingURL=CompletionResponse.ext.mjs.map
